import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import IconButton from '@mui/material/IconButton';
import useAuth from '../../hooks/useAuth';

const ActivityLogModal = props => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
    const [eventDate, setEventDate] = useState(dayjs(new Date().toLocaleString('sv-SE', { timeZoneName: 'short' }).slice(0, 16).replace(' ', 'T')));
    const [dateErr, setDateErr] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [descriptionErr, setDescriptionErr] = useState('');
    const maxDescLength = 1000;
    const maxTitleLength = 64;

    const {auth, persist} = useAuth();

    const validateForm = () => {
        let isValid = true;

        if(description.trim() === ''){
            isValid = false;
            setDescriptionErr('Required');
        }else{
            setDescriptionErr('');
        }

        // const currentUnixSeconds = Math.floor(Date.now() / 1000);
        // if(eventDate.unix() > currentUnixSeconds){
        //     isValid = false;
        //     setDateErr('Time is in the future');
        // }else{
        //     setDateErr('');
        // }

        return isValid;
    }

    const submitForm = () => {
        if(!validateForm()) return;

        let titleCopy = title.trim();

        let payload = {
            title: titleCopy === '' ? null : titleCopy,
            activity_time: eventDate.unix(),
            message: description.trim(),
            uid: auth?.id
        }

        props.addLog(payload);
    }

    return(
        <Modal
            show={props.activityModalOpen}
            onHide={() => props.setActivityModalOpen(false)}
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton style={{backgroundColor: props.modalLoading ? 'rgba(0,0,0,0.125)' : 'inherit'}}>
                Add log
            </Modal.Header>

            <Modal.Body style={{overflow:'hidden', backgroundColor: props.modalLoading ? 'rgba(0,0,0,0.125)' : 'inherit'}}>
                <TextField fullWidth label='Title (optional)' value={title} onChange={e => {if(e.target.value.length <= maxTitleLength) setTitle(e.target.value)}}
                    helperText={`${maxTitleLength - title.length} character${maxTitleLength - title.length === 1 ? '' : 's'} left`}
                />
                
                <br/>
                <br/>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                        <DateTimePicker
                            label="Activity date"
                            value={eventDate}
                            onChange={newDate => setEventDate(newDate)}
                        />
                    </DemoContainer>
                </LocalizationProvider>
                {dateErr !== '' && <><small className="text-error">{dateErr}</small><br/></>}


                <br/>

                <TextField 
                    fullWidth placeholder='Description*' value={description} onChange={e => {if(e.target.value.length <=  maxDescLength) setDescription(e.target.value)}} 
                    multiline rows={4} error={descriptionErr !== ''} 
                    helperText={descriptionErr === '' ? `${maxDescLength - description.length} character${maxDescLength - description.length === 1 ? '' : 's'} left` : descriptionErr}
                />
            </Modal.Body>

            <Modal.Footer style={{backgroundColor: props.modalLoading ? 'rgba(0,0,0,0.125)' : 'inherit'}}>
                <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                    <div style={{flex:'1', textAlign:'left', display:'flex', alignItems:'center', flexWrap:'wrap'}}></div>

                    <div style={{width:'fit-content', display:'flex', alignItems:'center', flexWrap:'wrap'}}>
                        <IconButton aria-label="site-create-next" onClick={() => submitForm()}>
                            <DoneIcon />
                        </IconButton>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ActivityLogModal;